import moment from 'moment'
import get from 'lodash/get'
import times from 'lodash/times'
import { getComponentsFromTripType } from '../utils/getComponentsFromTripType'

function mapTripType (origTripType) {
  const tripTypeDictionary = {
    'round-trip': 'RT',
    'one-way': 'OW',
    'multi-destination': 'MD'
  }
  return tripTypeDictionary[origTripType]
}

function mapCabinClass (origCabinClass) {
  const cabinClassDictionary = {
    Economy: 'ECO',
    'Premium Economy': 'PEC',
    Business: 'BUS',
    First: 'FST'
  }
  return cabinClassDictionary[origCabinClass]
}

function mapOneWayFlight (flight = undefined) {
  if (!flight) return {}

  const departureLocation = flight.departureAirport || {}
  const arrivalLocation = flight.arrivalAirport || {}
  const departureDate = moment.utc(flight.departureDate) || null
  return {
    id: 1,
    departureLocation,
    arrivalLocation,
    departureDate
  }
}

function mapRoundTripFlight (flight = undefined) {
  if (!flight) return {}

  const returnDate = moment.utc(flight.arrivalDate) || null
  const itinFromOneWay = mapOneWayFlight(flight)
  return Object.assign(itinFromOneWay, { returnDate })
}

function mapFlight (tripType = undefined, flight) {
  if (!tripType) return {}

  return tripType === 'one-way'
    ? mapOneWayFlight(flight)
    : mapRoundTripFlight(flight)
}

function areThereMultipleFlights (tripType, flights) {
  return (
    Array.isArray(flights) &&
    flights.length > 0 &&
    tripType === 'multi-destination'
  )
}

function mapFlightsByTripType (tripType, origFlights) {
  return areThereMultipleFlights(tripType, origFlights)
    ? origFlights.map(flight => mapFlight(tripType, flight))
    : mapFlight(tripType, origFlights[0])
}

export function mapNewFormSubmission (request, isSOPQ = false) {
  // TODO: Default the following search attributes to preserve the original flight search request criteria.
  //       Can revisit to retire or streamline these attributes
  const nearByAirports = {}
  const preferredAirline = {}
  const tripType = request.tripType ? mapTripType(request.tripType) : ''
  const cabinClass = request.cabinClass ? mapCabinClass(request.cabinClass) : ''

  // TODO: Use "productType" instead if the "isSOPQ" from the request data by form submission in home-components
  // TODO: Think about improving form submission data structure between flights home search v.s.SOPQ modal search
  const flights = isSOPQ
    ? [
      {
        departureAirport: request.departureAirport,
        departureDate: request.departureDate,
        arrivalAirport: request.arrivalAirport,
        arrivalDate: request.arrivalDate
      }
    ]
    : request.flights

  const oneWayFlight = flights
    ? mapFlightsByTripType(request.tripType, flights)
    : {}
  const roundTripFlight = flights
    ? mapFlightsByTripType(request.tripType, flights)
    : {}
  const multiDestFlights = flights
    ? mapFlightsByTripType(request.tripType, flights)
    : {}

  const ticketCount = 1
  const adultCount = request.adultsCount
  const youthsCount = request.youthsCount
  const childCount = request.childrenCount
  const infantCount = request.infantsCount

  return {
    nearByAirports,
    preferredAirline,
    tripType,
    cabinClass,
    oneWayFlight,
    roundTripFlight,
    multiDestFlights,
    ticketCount,
    adultCount,
    youthsCount,
    childCount,
    infantCount
  }
}

function getChildrenData (youthsCount, childrenCount, infantsCount) {
  return [].concat(
    times(youthsCount, () => ({ age: 17, lapChild: false })),
    times(childrenCount, () => ({ age: 14, lapChild: false })),
    times(infantsCount, () => ({ age: 0, lapChild: true }))
  )
}

export function mapShopSearchRequest (origRequest) {
  const {
    flights = [],
    productType,
    adultsCount = 1,
    youthsCount = 0,
    childrenCount = 0,
    infantsCount = 0
  } = origRequest

  const flightData = flights[0]
  const totalCount = adultsCount + youthsCount + childrenCount + infantsCount
  let rooms = totalCount > 4 ? 2 : 1
  if (origRequest.roomCount !== undefined) {
    rooms = origRequest.roomCount
  }
  const departureDate = moment.utc(flightData.departureDate).format('L')
  const returnDate = moment.utc(flightData.arrivalDate).format('L')
  const departureLocation = flightData.departureAirport
  const arrivalLocation = flightData.arrivalAirport
  const components = getComponentsFromTripType(productType, {
    roomCount: rooms,
    isPartialStayDateValid: false
  })
  const pivotComponentKey = get(components, '[0].index')
  const childrenData = getChildrenData(youthsCount, childrenCount, infantsCount)

  return {
    ...origRequest,
    departureDate,
    returnDate,
    departureLocation,
    arrivalLocation,
    pivotComponentKey,
    components,
    childrenData
  }
}
